import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c04d8f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RppGeneralTabs" }
const _hoisted_2 = { class: "RppGeneralTabs__tabs" }
const _hoisted_3 = {
  key: 0,
  class: "RppGeneralTabs__actions"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "RppGeneralTabs__actions"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/rpp/edit",
        class: _normalizeClass(["tabs__tab", { 'tab--active': _ctx.value === 'ftl' }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(" FTL ")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/rpp/ltl",
        class: _normalizeClass(["tabs__tab", { 'tab--active': _ctx.value === 'ltl' }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(" LTL ")
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    (_ctx.value === 'ftl')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "primary small",
            hint: "Выгрузить в Excel",
            onClick: _ctx.onExportData
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.value === 'ltl')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_the_button, {
            class: "primary small",
            hint: "Выгрузить в Excel",
            onClick: _ctx.onExportLtlData
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}